//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.TirePropertyBuilder.js";
import "../no/Expression.js";
import "../no/ExternalFileReferenceAdapter.js";
import "../no/Expression.js";
let d=[[[0,"ContactMethod",1,0],[0,"Dynamics",1,0],[1,"Iswitch",0,"Expression",0],[0,"IswitchDefinition",1,0],[1,"Lkx",0,"Expression",0],[1,"Lky",0,"Expression",0],[1,"Lkyc",0,"Expression",0],[1,"Lkzc",0,"Expression",0],[1,"Lmux",0,"Expression",0],[1,"Lmuy",0,"Expression",0],[1,"Ltr",0,"Expression",0],[0,"Name",1,0],[0,"SlipForces",1,0],[0,"StaticHold",1,0],[1,"StaticRadius",0,"Expression",0],[1,"StaticVerticalStiffness",0,"Expression",0],[0,"TireSide",1,0],[0,"TrackSide",1,0],[1,"VerticalDamping",0,"Expression",0],[1,"VerticalStiffness",0,"Expression",0]],[[["referenceObjectId"],"GetExternalFileReferenceAdapter",{R_:{adapter:"ExternalFileReferenceAdapter"}},1,0],[["referenceObjectId","adapter"],"SetExternalFileReferenceAdapter",{},2,0],[["adapter"],"GetExternalFileDefinitionKey",{R_:{externalFileDefinitionKey:''}},1,0],[["referenceObjectId","referenceType","externalFileSpec"],"EstablishReference",{R_:{adapter:"ExternalFileReferenceAdapter"}},3,0]],[]];
SPLM.Motion.TirePropertyMFTyreAndMFSwiftBuilder = class extends SPLM.Motion.TirePropertyBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.TirePropertyMFTyreAndMFSwiftBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.TirePropertyMFTyreAndMFSwiftBuilder.TrackSideType = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Motion.TirePropertyMFTyreAndMFSwiftBuilder.IswitchDefinitionType = Object.freeze({
    "Detailed" : "Detailed", "Integer" : "Integer"});

SPLM.Motion.TirePropertyMFTyreAndMFSwiftBuilder.TireSideType = Object.freeze({
    "Left" : "Left", "Right" : "Right", "Symmetric" : "Symmetric", "Mirrored" : "Mirrored"});

SPLM.Motion.TirePropertyMFTyreAndMFSwiftBuilder.SlipForcesType = Object.freeze({
    "NoMagicFormula" : "NoMagicFormula", "Longitudinal" : "Longitudinal", "Lateral" : "Lateral", "Uncombined" : "Uncombined", "Combined" : "Combined", "TurnSlip" : "TurnSlip"});

SPLM.Motion.TirePropertyMFTyreAndMFSwiftBuilder.DynamicsType = Object.freeze({
    "SteadyState" : "SteadyState", "RelaxationLinear" : "RelaxationLinear", "RelaxationNonLinear" : "RelaxationNonLinear", "RigidRing" : "RigidRing", "RigidRingWithInitStatics" : "RigidRingWithInitStatics"});

SPLM.Motion.TirePropertyMFTyreAndMFSwiftBuilder.ContactMethodType = Object.freeze({
    "SmoothRoad" : "SmoothRoad", "CircularCrossSection" : "CircularCrossSection", "MovingRoad" : "MovingRoad", "Road2D" : "Road2D", "Road3D" : "Road3D"});

export default SPLM;